import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import ClearIcon from '@material-ui/icons/Clear';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { AppConfig } from '../../../AppConfig';
import { CustomBaseEnityStyles } from '../../../styles/CustomStyles';
import { Dialog, Grid } from '@material-ui/core';
import { Tiles } from '../../../components/advertiser/Tiles';
import { Players } from '../../Players';
import { AppHelper } from '../../../helpers/AppHelper';

export class Campaigns extends BaseEntityPage {
  constructor(props) {
    super(props, { pageForOrgType: 'ADVERTISER' })
    this.pageKey = 'Campaigns'
    this.pageTitle = Helper.getString('campaigns')
    this.orgId = this.props.match.params.orgId
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: Helper.getString('campaigns'), to: this.baseRoute() + '/campaigns' },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['campaigns'], queryParams: { groupId: this.orgId, pb: 'fieldDef' } },
      { method: 'GET', paths: ['orgs', this.orgId] }
    ]
    this.apiData = {}
    this.noAdd = true
    this.emptyText = Helper.getString('emptyCampaigns')
    this.headerActions = [
      {
        label: 'New Campaign',
        icon: 'add',
        onClick: () => this.showAddCampaignModal(),
        type: 'icon-mobile'
      },
    ]
  }

  onFetchSuccess(results) {
    const result = results[0]
    this.setState({
      items: (result.items || []).filter(item => item.state !== 'CANCELLED'),
      stats: this.getStats(result, results[1]),
      org: results[1]
    })
  }

  renderTable() {
    // Instead of Table custom tiles view is rendered
    return (
      <Tiles
        items={this.state.items}
        org={this.state.org}
        orgId={this.orgId}
        emptyText={this.emptyText}
        onNext={this.onNext.bind(this)}
        nextPage={this.state.nextPage}
        nextPageState={this.state.nextPageState}
      />
    )
  }

  renderAboveTable() {
    return (
      <div className={css(Styles.container)}>
        {/* {this.renderStats()} */}
        {this.renderAddDialog()}
      </div>
    )
  }

  getStats(campaign, org) {
    const { items } = campaign
    const campaignStateInfo = AppHelper.campaignStateInfo()
    const stats = {
      ACTION_REQUIRED: { count: 0, title: Helper.getString('actionRequired'), color: campaignStateInfo.ACTION_REQUIRED.color },
      PENDING: { count: 0, title: Helper.getString('pending'), color: campaignStateInfo.PENDING.color },
      LIVE: { count: 0, title: Helper.getString('live'), color: campaignStateInfo.LIVE.color },
      DISABLED: { count: 0, title: Helper.getString('disabled'), color: campaignStateInfo.DISABLED.color }
    }
    for (const item of items) {
      const stateInfo = AppHelper.getAdvertiserCampaignState(item, org)
      if (stateInfo.state in stats) {
        stats[stateInfo.state].count += 1
      }
    }
    return stats
  }

  showAddCampaignModal = () => {
    this.setState({
      addCampaignModal: true
    })
  }

  renderAddDialog = () => {
    return (
      <Dialog
        open={this.state.addCampaignModal || false}
        onClose={() => this.setState({ addCampaignModal: false })}
        fullScreen
      >
        <div className={css(Styles.closeContainer)} onClick={() => this.setState({ addCampaignModal: false })}><ClearIcon /></div>
        <Players
          closeModal={() => this.setState({ addCampaignModal: false })}
          org={this.state.org} />
      </Dialog>
    )
  }

  renderStats = () => {
    return (
      <Grid container spacing={1}>
        {Object.keys(this.state.stats) && Object.keys(this.state.stats).length > 0 &&
          Object.keys(this.state.stats).map((key, index) => {
            return (
              <Grid item xs={6} sm={6} md={3} lg={3}>
                <div className={css(Styles.statusContainer)}>
                  <p className={css(Styles.statusText)} style={{ color: this.state.stats[key].color }}>{this.state.stats[key].title}</p>
                  <p className={css(Styles.statusCount)} style={{ color: this.state.stats[key].color }}>{this.state.stats[key].count}</p>
                </div>
              </Grid>
            )
          })
        }
      </Grid>
    )
  }
}


const Styles = (AppConfig.CUSTOM_STYLE) ? CustomBaseEnityStyles : StyleSheet.create({
  statusContainer: {
    display: 'flex',
    borderRadius: 16,
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    padding: '30px 16px',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      padding: '19px 12px',
    }
  },
  statusText: {
    fontSize: '16px',
    lineHeight: '21px',
    margin: 0,
    fontWeight: 500,
    flex: 1,
    ':first-letter': {
      textTransform: 'uppercase'
    },
    '@media (max-width: 767px)': {
      fontSize: '12px',
      lineHeight: '16px',
    }
  },
  statusCount: {
    fontSize: 28,
    margin: 0,
    fontWeight: 600,
    '@media (max-width: 767px)': {
      fontSize: 18,
      fontWeight: '24px',
    }
  },
  container: {
    display: 'flex',
    flex: 1,
    marginBottom: 32
  },
  closeContainer: {
    marginBottom: 10,
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '10px 40px 0px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    position: 'absolute'
  },
})


// WEBPACK FOOTER //
// ./src/screens/admin/advertisers/Campaigns.js